import domReady from "./utils/domReady";
import lightbox from "./utils/lightbox";

const { Rx, jQuery } = window;
const rootUrl = '/umbraco/Api';

const vinLookup = function ($) {
	$('comp-vin-lookup').each(function () {
		let $container = $(this);
		let $results = $container.find("comp-vin-results");
		let $vinNumber = $("#vin_number");
        let $searchBtn = $("#vin-search");
        let $btnFeedback = $("#feedback");
        let feedbackUrl = $btnFeedback.attr("href");
		$container.on('click', '.content-section > header', function () {
			let $section = $(this).parent();
			// client wants expansion to be independent - leaving this in case they change their minds
			//$container.find(".content-section").not($section).removeClass("expanded");
			$section.toggleClass('expanded');
		});
		function generateTruckMaterialsList(data) {
			let html = data.categories.map((cat) => {
				let contentSection = $('<div class="content-section"></div>');
				let contentHeader = $(`<header>${cat.name} <span class="subtotal">[${parseInt(cat.assetQuantity, 10)}]</span></span></header>`).appendTo(contentSection);
				let contentList = $('<ul class="content-list"></ul>').appendTo(contentSection);
				let contentItems = cat.assets.map(asset => {
					const typeLower = asset.type ? asset.type.toLowerCase() : 'img';
					if (typeLower === 'img' || typeLower === 'fab') {
						return $(`<li><a class="asset ${typeLower}-link" href="${asset.url}" target="_blank">${asset.title}</a></li>`);
					}

					// We're in VID Land
					let title = asset.title;
					let jwCode = '';

					if (asset.videoAsset) {						

						const time = asset.videoAsset.time
							&& typeof asset.videoAsset.time === 'string'
							? asset.videoAsset.time : '';

						if (time !== '')
							title += ` (${time})`;

						if (asset.videoAsset.jwCode && typeof asset.videoAsset.jwCode === 'string')
							jwCode = asset.videoAsset.jwCode;
					}
					
					let link = `<li><a class="asset ${typeLower}-link resource-item btn-jwlauncher" href="${asset.url}" target="_blank" type="${asset.type}" jwpid="+${jwCode}" assetid="${asset.assetId}" title="${asset.title}">${title}</a></li>`;

					return $(link).data('assetData', asset);

				});
				contentList.append(contentItems);
				return contentSection;
			});
			return html;
		}

		// endpoint: http://freightlinertrucks.azurewebsites.net/umbraco/surface/VIN/GetTruck?vin=GX1874

		function preventInvalidInput(event, val, regex, length) {
			let validation = {
				event,
				regex,
				length,
				error: false,
				valid: false
			};

			if (event.keyCode === 13 ||
				event.keyCode === 8 ||
				event.keyCode === 46 ||
				event.keyCode === 9 ||
				(35 <= event.keyCode && event.keyCode <=40 )) {
				validation.valid = true;
			} else if (!val.match(regex)) {
				event.preventDefault();
				validation.error = "regex";
			} else if (val.length > length && (document.getSelection().toString() === "" || val.indexOf(document.getSelection.toString()) !== -1)) {
				event.preventDefault();
				validation.error = "length";
			} else {
				validation.valid = true;
			}

			return validation;
		}

		function showError(error) {
			if (error.includes("status") || error == "" || !error) {
				error = "There are no resources available at this time for VIN " + $vinNumber.val() +".<br>You can find information for your truck model using the navigation below.";
			}
			let $searchError = $("#vin-search-error-msg");
			$container.addClass("error");
			if($searchError[0]){
				$searchError.html(error);
			}
			else {
				
				$results.html(`<div id"vin-search-error-msg">${$container.attr('error-message') || error}</div>`);
			}
		}

		function hideError() {
			$container.removeClass("error");
			$("#vin-search-error-msg").html("");
		}

		function removeLastChar(vin) {
			$vinNumber.val(vin.substring(0, vin.length - 1));
		}

		function trim (s, c) {
			if (c === "]") c = "\\]";
			if (c === "\\") c = "\\\\";
			return s.replace(new RegExp(
			  "^[" + c + "]+|[" + c + "]+$", "g"
			), "");
		}

		function getHash() {
			const path = trim(window.location.pathname, '/').split('/');
			const vin = path.length === 2 ? path[1] : 'abcdef';
			return `${rootUrl}/VIN/${vin}`;
		}

		function processResponse(response) {
			$("#vin-search-error-msg").empty();
			$container.removeClass('loading');
			$searchBtn.removeClass("loading");
			if (response.errorFlag === "true") {
				$results.empty();
				showError(response.errorMsg, response.serialNo);
				return;
			}
			hideError();
			// set vin to feedback url
			$btnFeedback.attr("href", feedbackUrl + "?vin=" + response.serialNo);

			$container.addClass("show-results");
			$results.empty();
			let total = response.categories.reduce((total, cat) => {
				return total + parseInt(cat.assetQuantity, 10);
			}, 0);
			let $header = $(`<h2>${response.model}</h2>`)
				.appendTo($results);
			let $contentSections = $(`<div id="content-sections"></div>`)
				.appendTo($results);
			let content = generateTruckMaterialsList(response);
			$contentSections.append(content);
			$("body, html").animate({
				scrollTop: 0
			}, 500);
        }

		$vinNumber.on("keyup", e => {
			let vin = $vinNumber.val();
			
			let validation = preventInvalidInput(e, vin, /^[0-9a-zA-Z]+$/, 6);

			switch(validation.error) {
				case "regex": {
					showError("Only letters (a-z and A-Z) and numbers are allowed.");
					removeLastChar(vin);
					break;
				}
				case "length": {
					showError("Only enter the last 6 characters of your VIN.");
					removeLastChar(vin);
					break;
				}
				case false: {
					hideError();
				}
			};
		});

		let search$ = $searchBtn[0] ? Rx.Observable.fromEvent($searchBtn, "click")
						.do(e => {
							e.preventDefault();
						})
						.map(() => {
							return $vinNumber.val()
						})
						.do(code => {
							if (code.length < 6) {
								showError("Enter the last 6 characters of your VIN.")
							}
						})
						.distinctUntilChanged((p, c) => {
							return p === c;
						})
						.filter(code => {
							return code.length === 6;
						})
						.do(code => {
							$searchBtn.addClass("loading");
						})
						.switchMap(code => {
							return Rx.Observable.fromPromise($.ajax({
								url: `${rootUrl}/vin/${code}`,
								method: "GET"
							})).retry(2);
						}) :
			Rx.Observable.fromPromise(
				$.ajax({
						url: getHash(),
						method: "GET"
				})
			).retry(2)
		
		search$
			.subscribe(response => {
				processResponse(response);
			}, (e) => {
				const errorResponse = {
					errorFlag: 'true',
					errorMsg: e.responseText,
					serialNo: '',
					categories: [],
					model: '',
				};
				processResponse(errorResponse);
			});

		
		$container.on("click", ".btn-help", (e) => {
			lightbox(`
				<div>
					<div id="vin-lookup-help">
						<img src="/images/vin-lookup-help.jpg" alt="Image of vin tag">
					</div>
				</div>`);
		});
	});
};
domReady.then(()=>vinLookup(jQuery));

export default vinLookup;